import { type CalendarGenerateInput, type CalendarGenerateSuccess, toResponseError } from '@terros/common'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'

export function useGenerateCalendarDemo(): AddHookResponse<CalendarGenerateInput, CalendarGenerateSuccess> {
  const mutation = useTantalimMutation<CalendarGenerateInput, CalendarGenerateSuccess>({
    url: '/calendar/demo/generate',
  })

  async function generate(input: CalendarGenerateInput): Promise<CalendarGenerateSuccess> {
    try {
      const result = await mutation.mutateAsync(input)
      return result
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, generate)
}
